module.exports = __webpack_public_path__ + "img/BarreraDown.9adc34ba.png";